<!--
@Author: Calvin Green <calvin>
@Date:   2021-10-06T10:42:05+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-06-22T20:44:29+02:00
@Copyright: Diversitude 2022
-->

<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
                    <i class="fas fa-arrow-left"></i> Back
                </b-button>
            </div>
            <div class="col-sm-12" style="margin-top: 10px;">
                <b-button @click="distributeSOPs()" class="me-2" variant="primary" >
                    Re-Distribute All SOP's
                </b-button>
            </div>
        </div>
        <hr>
    </div>
</template>
<script>
import Swal from 'sweetalert2'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    data:() => ({

    }),
    computed:{
        ...ccbAdminState
    },
    methods: {
        ...ccbAdminMethods,
        distributeSOPs() {
            var el = this;
            Swal.fire({
                title: "Are you sure you want to re-distrubute all SOP's?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes"
            }).then(result => {
                if (result.value) {
                    el.distributeAllSOPs({client_id: this.client_data.client.id})
                    .then(()=>{
                        Swal.fire({
                            toast: true,
                            position: 'top',
                            iconColor: 'white',
                            icon: 'success',
                            title:'Distributed!',
                            customClass: {     popup: 'success-toast' },
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    })
                }
            });
        }
    },
    mounted(){

    },
}
</script>

<style>

</style>
